import { render, staticRenderFns } from "./alarmer.vue?vue&type=template&id=0d4c1244"
import script from "./alarmer.vue?vue&type=script&lang=js"
export * from "./alarmer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports